import { useState, useEffect } from 'react';
import { Form, TextInput, Button, FileUploaderButton, Loading, FileUploaderItem } from 'carbon-components-react';
import styled from 'styled-components';
import { toaster } from '../../helpers/toaster';
import Select from "../../helpers/FixRequiredSelect";
import MyModal from '../../components/Modal/Modal';
import Label from '../../components/Label/Label';
import { selectStyles, formatReadOnlyStudyId } from '../../helpers/formUtils';
// api
import { getSimpleStudyList } from '../../api/studyListApi';

const LinkDetailModal = ({
	mode = "create",
	linkId = null,
	open = false,
	linkData = {
		id: "",
		name: "",
		url: "",
		type: "",
		link: null,
		study: "",
	},
	onClose = () => {},
	confirmSave,
	confirmUpdate,
	linksLoading,
	setLinksLoading,
	isStudyDetail,
  studyOrgStudyId,
  studyPgId,
  studyListOptions,
}) => {
	// create/edit
	const [modalMode, setModalMode] = useState("create");

	// component data
	const [linkInfo, setLinkInfo] = useState({});
	const [linkFile, setLinkFile] = useState();
	// for study list dropdown
	const [studyList, setStudyList] = useState([]);

	// for when editing a study
	const [initialStudy, setInitialStudy] = useState({});

	// listen for modal "mode" changes create/edit/etc
	useEffect(() => setModalMode(mode), [mode]);

	// listen for linkData changes and make updates
	useEffect(() => {
		clearForm();
		// set link passed from props or default value
		setLinkInfo(linkData);

		// get initially selected item
		if (linkData && studyList && studyList.length) {
			let selectedStudy = studyList.find(item => item.value === linkData.study) || studyList[0];
			setInitialStudy(selectedStudy);
		}
	}, [linkData]);

	// load study list
	useEffect(() => {
		if (studyListOptions) {
			setStudyList(studyListOptions);
			if (studyListOptions.length) {
				setInitialStudy([studyListOptions[0]]);
				changeLinkInfo({
					...linkInfo,
					study: studyListOptions[0].value
				});
			}
			setLinksLoading(false)
			return;
		}
		getSimpleStudyList().then(res => {
			if (res && res.length) {
				let studies = res.map(item => ({
					value: item.id,
					label: item.org_study_id,
					}));
				setStudyList(studies);
				setInitialStudy([studies[0]]);
				changeLinkInfo({
					...linkInfo,
					study: studies[0].value
				});
			}
			setLinksLoading(false)
		}).catch(error => {
			toaster("Failed to get simple study list", "error")
			setLinksLoading(false)
		});
	}, []);

	useEffect(() => {
		if(mode === 'create'){
			setLinkInfo({
				...linkInfo,
				study: studyPgId,
			})
		}
	}, [modalMode, studyPgId])

	// link handler
	const changeLinkInfo = (newData) => {

		setLinkInfo(newData);
	};

	const changeLinkFile = (newData) => {
		if(linkInfo?.button_text){
			setLinkInfo({
				...linkInfo,
				button_text: ""
			})
		}
		// setLinkInfo(newData);
		setLinkFile(newData)
	};


	// study handler
	const changeSelectedStudy = e => {
		setInitialStudy(e);
		changeLinkInfo({
			...linkInfo,
			study: e.value,
		});
	};

	// garbage collection
	const clearForm = () => {
		const linkData = {
			id: "",
			button_text: "",
			url: "",
			description: "",
			logo: null,
			study: "",
		}
		if(isStudyDetail){
			linkData.study = studyPgId
		}
		setLinkInfo(linkData);
		setInitialStudy([]);
		setLinkFile(null);
	}

	// save api call
	const saveLink = (e) => {
		// form will handle most of validation, so button type="submit" thats why we preventDefault
		e.preventDefault();

		// stull that form doesn't validate
		if (!linkInfo) {
			return;
		}

		// start processing indicator
		setLinksLoading(true);

		// create a proper js form object for file transfer
		let formData = new FormData();
		if(linkFile){
			formData.append('logo', linkFile, linkFile.name);
		}
		if(linkInfo.button_text) formData.append('button_text', linkInfo.button_text)

		if(linkInfo.description) formData.append('description', linkInfo.description)

		if(linkInfo.url) formData.append('url', linkInfo.url)

    // formData.append('url', linkInfo.url);
		formData.append('study', linkInfo.study);

		if (modalMode === "create") {
			confirmSave(formData).then((data) => {
				if (data) clearForm();
			})
		} else {
			confirmUpdate(formData, linkId)
		}
	};

	const addBtnStyle = {
		padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
		width: "fit-content",
		marginLeft: "18px",
	};

	const additionalProps = {
		className: 'some-class',
		onSubmit: saveLink
	};

	return (
		<MyModal
			modalHeading="Link Details"
			size="md"
			open={open}
			onRequestClose={()=>{
				onClose();
			}}
		>
			<LinkModalContent>

				{
					linksLoading ? 
					<Loading/> 
					:
					<></>
				}
				
				<Form {...additionalProps}>

					<PartWrapper>
						<InputWrapper>
							{(mode === "create" && !isStudyDetail) ?
								<>
									<Label>Study ID*</Label>
									<Select
										id="studyList"
										options={studyList}
										value={initialStudy}
										onChange={e => changeSelectedStudy(e)}
										classNamePrefix="xogene"
										className="multi-select"
										styles={selectStyles()}
										disabled={linksLoading}
										isSearchable
										required
									/>
								</>
								:
								// linkData?.org_study_id || "-"
								( mode === "create" && isStudyDetail) ? 
								formatReadOnlyStudyId( studyOrgStudyId || "-")
								: formatReadOnlyStudyId(linkData?.org_study_id || "-")
								

							}
						</InputWrapper>
					</PartWrapper>

          {/* logo = models.FileField(upload_to=get_tenant_logos_folder_path, storage=STORAGE_CLASS, null=True)
    button_text = models.CharField(default='', max_length=200, blank=True)
    url = models.CharField(default='', max_length=200, blank=True)
    description = models.TextField(default='', blank=True) */}
    			<PartWrapper>
						<InputWrapper>
							<TextInput
								value={linkInfo?.url || ""}
								labelText="URL"
								helperText="URL must have https:// at the beginning"
								// placeholder="Please enter Link Name"
								onChange={e => changeLinkInfo({
								...linkInfo,
								url: e.target.value,
								})}
								// required
								disabled={linksLoading}
							/>
						</InputWrapper>
					</PartWrapper>
					<PartWrapper>
						<InputWrapper>
							<TextInput
								value={linkInfo?.button_text || ""}
								labelText="Button Text"
								helperText="Button text and logo can not be added in a single link."
								// placeholder="Please enter Link Name"
								disabled={(linkFile || linkInfo?.logo) ? true : false}
								onChange={e => changeLinkInfo({
								...linkInfo,
								button_text: e.target.value,
								})}
								// required
								// disabled={linksLoading}
							/>
						</InputWrapper>
					</PartWrapper>
					<PartWrapper>
						<InputWrapper>
							<TextInput
								value={linkInfo?.description || ""}
								labelText="Description"
								// placeholder="Please enter Link Name"
								onChange={e => changeLinkInfo({
								...linkInfo,
								description: e.target.value,
								})}
								disabled={linksLoading}
							/>
						</InputWrapper>
					</PartWrapper>
					<PartWrapper>
						<Label>Logo</Label>
						<FileUploadStyled>
							<PartWrapper>
							{mode !== "create" && 
							// <PaddingWrapper>
							<div style={{"marginBottom": "18px"}}>
								<span>Current File: </span>
								{/* <a href={linkInfo?.logo} target="_blank">{linkInfo?.logo_info?.title}</a>
                 */}
                 <img width="200" src={linkInfo?.logo} alt="Logo Info" />
							</div>
							}
							<FileUploaderButton
								id="linkFile"
								disableLabelChanges={true}
								buttonKind="ghost"
								labelText="Select a file to attach"
								onChange={e => changeLinkFile(e.target.files[0])}
								multiple={false}
								disabled={linksLoading}
								accept={['.png', '.jpg', '.jpeg']}
							/>
							{linkFile && <FileUploaderItem
								name={linkFile?.name}
								status="edit"
								onDelete={e => setLinkFile(null)}
							/>}
							</PartWrapper>
						</FileUploadStyled>
					</PartWrapper>

					<ModalFooter>
						<Button 
							kind="secondary"
							onClick={onClose}
							style={addBtnStyle}
							disabled={linksLoading}
						>Cancel</Button>

						<Button
							type="submit"
							kind="primary"
							// saveLink sent to form props
							style={addBtnStyle}
							disabled={linksLoading}
						>{ (modalMode === "create") ? "Create Link" : "Update Link" }</Button>
					</ModalFooter>

				</Form>

			</LinkModalContent>
		</MyModal>
	)
};

export default LinkDetailModal;

const LinkModalContent = styled.div`
	display: flex;
	flex-direction: column;
`

const PartWrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 18px;
`

const InputWrapper = styled.div`
	width: 100%;
`

const FileUploadStyled = styled(InputWrapper)`
  background-color: #f4f4f4;
	padding-left: 1rem;
	padding-bottom: 1rem;
	padding-top: 1rem;
  // button
  .bx--btn--ghost {
    color: black;
    border: 1px solid #8d8d8d;
    border-radius: 5px;
    background-color: #d9d9d9;
  }

  .bx--btn--ghost:hover, .bx--btn--ghost:active {
    color: #0f62fe;
    border-color: #0f62fe;
  }

  .bx--file-container {
    width: 100%;
  }

  .bx--file__selected-file {
    border-bottom: 1px dotted black;
    color: black;
  }
`

const ModalFooter = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
`